<template lang="pug">
  filters-common(
    v-if='loaded',
    :data='filters'
  )
</template>

<script>
import FiltersCommon from '../filter/FiltersCommon'
import GraficoIdEnum from '../../../enum/graficoId'

export default {
  name: 'DailyBankStatment',

  components: {
    FiltersCommon
  },

  data () {
    return {
      loaded: false,
      gadget: this.$store.getters.availableGadgets.find(g => g.funcionalidade.idFuncionalidade === GraficoIdEnum.SALDO_BANCARIO),
      filters: [
        {
          name: 'agrupamentoConta',
          options: [],
          onChange: this.setSelected('setAccountSelectedBankBalance', 'agrupamentoConta'),
          hasGroups: true,
          order: 1,
          convertIdTo: id => Number(id)
        }
      ]
    }
  },

  computed: {
    periodoDashboard () {
      return this.$store.getters.periodFilterBankBalance
    }
  },

  watch: {
    periodoDashboard: {
      handler () {
        this.setFilter('periodoResultado', this.periodoDashboard)
      },
      deep: true
    }
  },

  methods: {
    setSelectFlags () {
      for (const filter of this.filters) {
        const param = this.getParam(filter.name)
        if (filter.hasGroups) {
          filter.convertIdTo = filter.convertIdTo || (id => id)
          const paramValue = param ? filter.convertIdTo(param.valor) : null
          for (const group of filter.options) {
            if (paramValue === null) {
              group.__selected = false
            } else {
              const index = group.options.findIndex(groupOption => filter.convertIdTo(groupOption.id) === paramValue)
              if (index === -1) {
                group.__selected = false
              } else {
                group.__selected = true
                group.options[index].__selected = true
              }
            }
          }
        } else {
          for (const option of filter.options) {
            option.__selected = param && param.valor === option.id
          }
        }
      }
      this.loaded = true
    },

    getParam (filterName) {
      return this.gadget.gadgetParam.find(param => param.nome === filterName)
    },

    setFilter (filterName, value) {
      if (!this.gadget || !this.gadget.gadgetParam || this.gadget.gadgetParam.length === 0) {
        return
      }

      const param = this.getParam(filterName)
      if (!param) {
        return
      }

      if (param.valor !== value) {
        param.valor = value instanceof String ? value : value.id
        this.$store.dispatch('loadingData')
        this.$store.dispatch('cancelDashboardRequests')
        this.$store.dispatch('setGadgetConfig', this.gadget)
          .finally(() => {
            this.$store.dispatch('dataLoaded')
          })
      }
    },

    setSelected (eventName, filterName) {
      return result => {
        if (result && result.id) {
          this.$store.dispatch(eventName, result)
          this.setFilter(filterName, result.id)
        }
      }
    },

    async getAccounts () {
      const response = await this.$store.dispatch('getBankAccounts', '/dashboard/listBankAccounts')
      const accounts = response.data.data.filter((bankAccount) => {
        return bankAccount.ativo
      })

      const groups = await this.$store.dispatch('getEstablishmentGroups')

      return [
        {
          groupName: 'Grupos',
          options: [
            {
              id: '-1',
              label: this.$t('dashboard.filtro.semAgrupamento'),
              tipo: 'GRUPO'
            },
            ...groups
              .map(group => {
                return {
                  id: group.id,
                  label: group.nome,
                  tipo: 'GRUPO'
                }
              })
          ]
        },
        {
          groupName: 'Contas',
          default: true,
          options: [
            {
              id: '0',
              label: this.$t('dashboard.filtro.tipo.T'),
              tipo: 'CONTA_BANCARIA'
            },
            ...accounts
              .map(account => {
                return {
                  id: account.id,
                  label: `${account.banco.codigo} - ${account.nome}`,
                  codigoBanco: account.banco.codigo,
                  nomeConta: account.nome,
                  tipo: 'CONTA_BANCARIA'
                }
              }).sort((a, b) => {
                if (a.codigoBanco > b.codigoBanco) {
                  return 1
                }
                if (a.codigoBanco < b.codigoBanco) {
                  return -1
                }

                return a.nomeConta.localeCompare(b.nomeConta)
              })
          ]
        }
      ]
    }
  },

  created () {
    const self = this
    this.getAccounts()
      .then(accounts => {
        const accountFilter = self.filters.find(filter => filter.name === 'agrupamentoConta')
        accountFilter.options = accounts
        self.setSelectFlags()
      })
  }
}
</script>



// WEBPACK FOOTER //
// DailyBankStatment.vue?e2f5a9fa